export default __webpack_public_path__ + "static/doodle-underline-db56e4da1839019b15289e7ed0f7299d.svg";